import CreateSuspendedComponent from "containers/app/CreateSuspendedComponent";

export const ClientManagementForm = CreateSuspendedComponent(
  () => import("../ClientManagementForm"),
);
export const MainTab = CreateSuspendedComponent(
  () => import("../Tabs/MainTab"),
);
export const DashboardTab = CreateSuspendedComponent(
  () => import("../Tabs/DashboardTab"),
);
export const TeamsTab = CreateSuspendedComponent(
  () => import("../Tabs/TeamsTab"),
);
export const UsersTab = CreateSuspendedComponent(
  () => import("../Tabs/UsersTab"),
);
export const ClientLocation = CreateSuspendedComponent(
  () => import("../Tabs/ClientLocation"),
);
export const UsageTab = CreateSuspendedComponent(() => import("./UsageTab"));
export const DeveloperTab = CreateSuspendedComponent(
  () => import("../Tabs/DeveloperTab"),
);
export const AddonsTab = CreateSuspendedComponent(
  () => import("../Tabs/AddonsTab"),
);
export const EnvironmentVariablesTab = CreateSuspendedComponent(
  () => import("../Tabs/EnvironmentVariablesTab"),
);
